import { Action, createReducer, on } from '@ngrx/store';

import { LoginMethod } from '@personal-area/global/authorization/models';
import { DataLayer } from '@personal-area/global/gtm';
import { Logout } from '@personal-area/global/state';

import {
  SetEventDispatchStatus,
  SetIsLoginAfterRegistration,
  SetLoginMethod,
  SetUserData,
} from '../actions/login-analytics.actions';

export interface LoginAnalyticsState {
  user: DataLayer['user'];
  isLoginAfterRegistration: boolean;
  method: LoginMethod;
  isEventSent: boolean;
}

export const initialState: LoginAnalyticsState = {
  user: null,
  isLoginAfterRegistration: null,
  method: null,
  isEventSent: null,
};

export const reducer = createReducer(
  initialState,
  on(SetUserData, (state, { user }) => {
    return {
      ...state,
      user,
    };
  }),
  on(SetIsLoginAfterRegistration, (state, { isLoginAfterRegistration }) => {
    return {
      ...state,
      isLoginAfterRegistration,
    };
  }),
  on(SetLoginMethod, (state, { method }) => {
    return {
      ...state,
      method,
    };
  }),
  on(SetEventDispatchStatus, (state, { isEventSent }) => {
    return {
      ...state,
      isEventSent,
    };
  }),
  on(Logout, (state) => initialState),
);

export const loginAnalyticsReducer = (
  state: LoginAnalyticsState | undefined,
  action: Action,
): LoginAnalyticsState => reducer(state, action);
